<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>车间管理</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-row>
				<el-col :span="18">
					<el-form :inline="true">
						<el-form-item label="搜索">
							<el-input v-model="nameSearch" placeholder="按名称搜索">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="info" @click="search()">搜索</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="6" style="text-align:right;">
					<el-button type="primary" icon="el-icon-plus" @click="add">添加车间</el-button>
				</el-col>
			</el-row>
		</div>

		<el-table border v-loading="tableLoading" :data="tableData">
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="code" label="车间编号" width="100"> </el-table-column>
			<el-table-column prop="name" label="车间名称"> </el-table-column>
			<el-table-column label="车间类型" width="120">
				<template slot-scope="scope">
					<span v-text="getTypeStr(scope.row)"></span>
				</template>
			</el-table-column>

			<el-table-column prop="device_num" label="设备数" width="100"> </el-table-column>
			<el-table-column prop="worker_num" label="工人数" width="100"> </el-table-column>
			<el-table-column label="操作" width="150" fixed="right">
				<template slot-scope="scope">
					<el-button type="text" icon="el-icon-edit" v-on:click="edit(scope.row)">编辑</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-popconfirm title="确定删除该车间吗？" @onConfirm="handleDelete(scope.row)">
						<el-button icon="el-icon-delete" slot="reference" type="text">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="currentChange" @size-change="sizeChange"> </el-pagination>

		<!-- 编辑车间信息  -->
		<el-dialog :title="formDialogTitle" :visible.sync="formDialogVisable" width="500px">
			<div>
				<el-form ref="workshopForm" :rules="rules" :model="form" label-position="right" label-width="80px">
					<el-form-item label="车间名称" prop="name">
						<el-input v-model.trim="form.name" placeholder="车间名称"></el-input>
					</el-form-item>
					<el-form-item label="编号" prop="code">
						<el-input v-model.trim="form.code" placeholder="车间编号"></el-input>
					</el-form-item>
					<el-form-item label="车间类型" prop="type">
						<el-select v-model.trim="form.type" placeholder="请选择">
							<el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="设备数" prop="device_num">
						<el-input-number v-model.number="form.device_num" :min="0" :max="999999999"></el-input-number>
					</el-form-item>

					<el-form-item label="工人数" prop="worker_num">
						<el-input-number v-model.number="form.worker_num" :min="0" :max="999999999"></el-input-number>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="formDialogVisable = false">取消</el-button>
				<el-button type="primary" v-on:click="save('workshopForm')">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { workshopRequest } from '@/network/requests/workshop'
	export default {
		data() {
			this.workshopTypes = {
				0: { text: '印刷' },
				1: { text: '复合' },
				2: { text: '分切' },
				3: { text: '复卷' },
			}

			/**
			 * 车间编号重名检查
			 * @param {*} rule
			 * @param {*} value
			 * @param {*} callback
			 */
			var validateCodeExist = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入车间编号'))
				} else {
					var msg = '车间编号已存在，请修改编号！'
					//检查名称是否重复。
					workshopRequest.queryAll({ code: value }).then(res => {
						if (res.length > 1) {
							callback(new Error(msg))
						} else if (res.length == 1) {
							var data = res[0]

							if (this.form._id) {
								if (data._id.$oid != this.form._id.$oid) {
									callback(new Error(msg))
								} else {
									callback()
								}
							} else {
								callback(new Error(msg))
							}
						} else {
							callback()
						}
					})
				}
			}

			/**
			 * 车间名称重名检查
			 * @param {*} rule
			 * @param {*} value
			 * @param {*} callback
			 */
			var validateNameExist = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入车间名称'))
				} else {
					var msg = '车间名称已存在，请更换名称！'
					//检查名称是否重复。
					workshopRequest.queryAll({ name: value }).then(res => {
						if (res.length > 1) {
							callback(new Error(msg))
						} else if (res.length == 1) {
							var data = res[0]

							if (this.form._id) {
								if (data._id.$oid != this.form._id.$oid) {
									callback(new Error(msg))
								} else {
									callback()
								}
							} else {
								callback(new Error(msg))
							}
						} else {
							callback()
						}
					})
				}
			}

			return {
				tableData: [],
				pageCount: 1,
				pageSize: 10,
				pageIndex: 1,
				formDialogTitle: '',
				formDialogVisable: false,
				form: {},
				rules: {
					name: [
						{ required: true, message: '请输入车间名称', trigger: 'blur' },
						{ validator: validateNameExist, trigger: 'blur' },
					],
					code: [
						{ required: true, message: '请输入车间编号', trigger: 'blur' },
						{ validator: validateCodeExist, trigger: 'blur' },
					],
					type: [{ required: true, message: '请选择车间类型', trigger: 'change' }],
					device_num: [{ type: 'number', message: '请输入数字' }],
					worker_num: [{ type: 'number', message: '请输入数字' }],
				},
				tableLoading: false,
				nameSearch: '',
			}
		},
		computed: {
			/**
			 * 车间类型。
			 */
			types() {
				var options = []
				for (var item in this.workshopTypes) {
					options.push({
						label: this.workshopTypes[item].text,
						value: parseInt(item),
					})
				}

				return options
			},
		},
		methods: {
			/**
			 * 添加车间。
			 */
			add() {
				this.form = {
					type: 0,
				}
				this.formDialogTitle = '添加车间'
				this.formDialogVisable = true
			},
			/**
			 * 类型。
			 */
			getTypeStr(row) {
				var type = row.type ?? 0
				if (type in this.workshopTypes) {
					return this.workshopTypes[type].text
				}
				return '--'
			},
			/**
			 * 搜索。
			 */
			search() {
				this.pageIndex = 1
				this.loadData()
			},
			/**
			 * 加载数据。
			 */
			loadData() {
				this.tableLoading = true
				var filter = undefined
				if (this.nameSearch) {
					filter = {
						name: this.nameSearch,
					}
				}

				workshopRequest
					.searchPage(this.pageSize, this.pageIndex, filter)
					.then(({ data }) => {
						this.tableData = data._embedded
						this.pageCount = data._total_pages
					})
					.finally(() => {
						this.tableLoading = false
					})
			},
			/**
			 * 切换页码。
			 */
			currentChange(page) {
				this.pageIndex = page
				this.loadData()
			},
			/**
			 * 切换页码。
			 */
			sizeChange(size) {
				this.pageSize = size
				this.pageIndex = 1
				this.loadData()
			},
			/**
			 * 保存车间。
			 */
			save(formName) {
				var p = null
				console.log(this.form)
				this.$refs[formName].validate(valid => {
					if (valid) {
						if (this.form._id) {
							p = workshopRequest.modifyById(this.form._id.$oid, this.form)
						} else {
							p = workshopRequest.upload(this.form)
						}

						p.then(res => {
							this.loadData()
						}).finally(() => {
							this.formDialogVisable = false
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},
			/**
			 * 编辑车间。
			 */
			edit(row) {
				this.formDialogTitle = '编辑车间信息'
				this.formDialogVisable = true
				this.form = { ...row }
			},
			/**
			 * 删除车间。
			 */
			handleDelete(row) {
				var id = row._id.$oid
				workshopRequest.deleteById(id).then(res => {
					this.loadData()
				})
			},
		},
		created() {
			this.loadData()
		},
	}
</script>

<style></style>
